module.exports = __webpack_public_path__ + "img/poly-3.9b18e97d.png";